import { useCallback } from 'react';
import { bridge } from '../utils';
import { useAnalyticsContext } from '../context/AnalyticsContext';
import type { LogAnalyticsEventParams } from '../utils/bridge/logAnalyticsEvent/types';

export const useLogAnalyticsEvent = () => {
  const { getLogging } = useAnalyticsContext();

  return useCallback(
    (params: LogAnalyticsEventParams) => {
      const logging = getLogging();
      return bridge.logAnalyticsEvent({
        ...params,
        analytics: {
          ...logging.analytics,
          ...params.analytics,
        },
        ably_only_log: {
          ...logging.ably_only_log,
          ...params.ably_only_log,
        },
      });
    },
    [getLogging],
  );
};
